import { DashboardSection } from '@/components/Dashboard/enums/shared';
import { FolderScope } from '@/enums/folder-scope.enum';

export const getDashboardSectionFromScope = (scope?: FolderScope | null): DashboardSection => {
  if (scope === FolderScope.WORKSPACE) {
    return DashboardSection.WorkspaceFiles;
  }

  return DashboardSection.RecentRecipes;
};
